import { EntityRequestAddchg } from "../../entity/EntityRequestAddchg";

export class DtoRequestAddchgsDeleteRes extends EntityRequestAddchg {
  public message: string | null = null;
}
